export interface SalesPackage {
  id: number;
  name: string;
  description: string;
  price: number;
  city: string;
  isCustom?: boolean;
  type: string;
}

export interface CartPackages {
  id: string;
  package: SalesPackage;
  dates: string[];
  comment?: string;
  additionalField?: string;
  station1: string;
  station2: string;
  stations: object;
}

export const NullPackage: SalesPackage = {
  id: 0,
  name: "",
  description: "",
  price: 0,
  city: "",
  isCustom: false,
  type: ""
};

export interface BackendCartRequest {
  packageId: number;
  packageName: string;
  packagePrice: number;
  dates: string[];
  station1: string;
  station2: string;
  stations: object;
}

export interface PackageListResponse {
  brand: string;
  category: string;
  description: string;
  group: string;
  group_title: string;
  id: number;
  is_custom: boolean;
  is_multi_coverage: boolean;
  is_renewal: boolean;
  list_title: string;
  long_title: string;
  order: number;
  place_ids: number[];
  price: {
    monthly: number;
    tax: number;
    total: number;
    yearly: number;
  };
  product: number;
  section: string;
  signup_bonus: number;
  cities?: string;
  package_type?: string;
}

export interface BackendPackageListResponse {
  packages: PackageListResponse[];
  cities: string[];
}

export interface BackendCart {
  package_id: number;
  package_name: string;
  price_per_package: number;
  dates: string[];
  package_description: string;
}

export const lacs = "lakhs";
